(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ml_snippet-forms-labels"] && !Shopify.designMode) return;
  try {
    const hoistNestedLabels = (root) => {
    root.querySelectorAll('input, textarea').forEach((field) => {
      if (!field.id) return;

      const label = root.querySelector(`label[for="${CSS.escape(field.id)}"]`);
      if (!label || label.dataset.mlHoisted === 'true') return;

      const parent = label.parentElement;
      if (!parent || parent.tagName === 'FORM' || parent.querySelector(':scope > button')) return;

      const phone = parent.parentElement;
      if (!phone || phone.tagName === 'FORM' || !phone.querySelector(':scope > button:not([type="submit"])')) return;

      phone.prepend(label);
      label.dataset.mlHoisted = 'true';
    });
  };

  const placeLabelsAbove = (embed) => {
    const root = embed.shadowRoot;
    if (!root) return;

    hoistNestedLabels(root);
    if (root.querySelector('[data-ml-labels-above]')) return;

    const style = document.createElement('style');
    style.dataset.mlLabelsAbove = 'true';
    style.textContent = [
      'label, legend, form p { font-family: var(--font-body--family) !important; font-style: var(--font-body--style) !important; font-weight: var(--font-body--weight) !important; }',
      'label, legend { font-size: var(--font-paragraph--size) !important; }',
      'button[type="submit"] { font-family: var(--font-heading--family) !important; font-style: italic !important; font-weight: 400 !important; letter-spacing: 0.03em !important; font-size: 20px !important; text-transform: var(--button-text-case-primary, none) !important; }',
      'div:has(> input):has(> label), div:has(> textarea):has(> label) { display: flex !important; flex-direction: column !important; align-items: stretch !important; }',
      'div:has(> input) > label, div:has(> textarea) > label, [class*="formInputFieldLabel"] { position: static !important; inset: auto !important; transform: none !important; order: -1; width: 100%; max-width: 100% !important; margin: 0 0 0.75rem !important; padding: 0; color: var(--color-foreground) !important; line-height: 1.3; word-break: normal; overflow-wrap: break-word; }',
      'div:has(> [class*="formInputFieldLabel"]) { display: flex !important; flex-direction: column !important; align-items: stretch !important; }',
      'div:has(> textarea)::before { content: none !important; display: none !important; }',
      'div[class*="formPhone"] { display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; align-items: center !important; column-gap: 0.5rem; }',
      'div[class*="formPhone"] > div:has([class*="formInputFieldLabel"]) { display: contents !important; }',
      'div[class*="formPhone"] [class*="formInputFieldLabel"] { flex: 1 0 100% !important; }',
      'div[class*="formPhone"] input:not([type="checkbox"]):not([type="file"]) { width: 1px !important; max-width: none !important; flex: 1 1 0 !important; min-width: 0 !important; }',
      'div[class*="formPhone"] > div:not([class*="formField"]) { flex: 0 0 auto !important; }',
      'div:has(> input) > input:not([type="checkbox"]):not([type="file"]), div:has(> textarea) > textarea { width: 100% !important; max-width: 100% !important; min-width: 0; box-sizing: border-box; padding-top: 0.75rem !important; padding-bottom: 0.75rem !important; }',
      'div:has(> button):has(> input) { flex-direction: row !important; flex-wrap: wrap !important; align-items: center !important; column-gap: 0.5rem; }',
      'div:has(> button):has(> input) > label { flex: 1 0 100%; }',
      'div:has(> button):has(> input) > button { flex: 0 0 auto; }',
      'div:has(> button):has(> input) > input { width: auto !important; flex: 1 1 0 !important; }',
    ].join(' ');
    root.appendChild(style);
  };

  const watchForm = (embed) => {
    if (embed.dataset.mlLabelsWatched === 'true') {
      placeLabelsAbove(embed);
      return;
    }

    embed.dataset.mlLabelsWatched = 'true';

    const bind = () => {
      placeLabelsAbove(embed);
      if (!embed.shadowRoot || embed.dataset.mlLabelsObserving === 'true') return Boolean(embed.shadowRoot);

      embed.dataset.mlLabelsObserving = 'true';
      new MutationObserver(() => placeLabelsAbove(embed)).observe(embed.shadowRoot, {
        childList: true,
        subtree: true,
      });
      return true;
    };

    if (bind()) return;

    const started = Date.now();
    const timer = setInterval(() => {
      if (bind() || Date.now() - started > 10000) clearInterval(timer);
    }, 200);
  };

  const watchForms = () => {
    document.querySelectorAll('shopify-forms-embed').forEach(watchForm);
  };

  watchForms();
  new MutationObserver(watchForms).observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
